function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionCampaignRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.42 25.492a1.001 1.001 0 01-.594 1.277l-3.176 1.168a1.003 1.003 0 01-1.287-.6l-.347-.967 5.052-1.858.353.98zM13.208 5.574a1.947 1.947 0 00-3.215.721L4.516 20.96l-1.882 1.888a2.178 2.178 0 000 3.072l3.433 3.444a2.152 2.152 0 003.06 0l1.88-1.888 1.132-.416.344.955a2.974 2.974 0 001.554 1.703c.404.188.834.283 1.267.283.348 0 .699-.062 1.036-.186l3.177-1.168a3.01 3.01 0 001.787-3.832l-.358-.993 4.764-1.752c1.345-.486 1.729-2.212.718-3.227L13.207 5.574zM18.005 6.998h2V2h-2v4.998zM25.002 13.995H30v-2h-4.998v2zM27.708 5.705l-1.414-1.414-3.998 3.998 1.414 1.414 3.998-3.998z",
    fill: props.color
  }));
}

export default SvgIconPromotionCampaignRexFilled;